<template>
  <main class="l-main p-register">
    <div class="l-block">
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content provisional">
        <div class="message">
          <h1>
            仮会員登録が完了しました。
            <br />
            本登録用のメールをご確認後に本登録となります。
          </h1>
          <div class="c-text--center">
            <img
              :src="require('@/assets/img/img-register-provisional.gif')"
              alt="仮会員登録となります"
            />
            <p>
              お客様のメールアドレス宛に、本登録用のメールを送信いたしました。
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TitleRegister from '@/components/TitleRegister';
import Progress from '@/components/Progress';

export default {
  components: {
    TitleRegister,
    Progress
  },
  data() {
    return {
      progress: [
        {
          label: '内容入力'
        },
        {
          label: '内容確認'
        },
        {
          current: true,
          label: '登録完了'
        }
      ]
    };
  }
};
</script>
